import React from "react";
import { ErrorAlert } from "components/errorAlert/ErrorAlert";

export const ErrorDisplay = () => {
  return (
    <ErrorAlert
      title="An Unknown Error Occurred."
      errorCode="error"
      buttonTitle="Refresh"
      onClick={() => window.location.reload()}
    >
      <p>
        We apologize for the inconvenience.
        <br />
        For related inquiries, please contact syncbox@dorosee.kr.
      </p>
    </ErrorAlert>
  );
};
